export function loopArray(array, activePath) {
  var result = [];
  for (let i = 0; i < array?.length; i++) {
    var obj = array[i];
    var keys = Object.keys(obj);
    if (keys.some((key) => key === activePath)) {
      result.push(...obj[activePath]);
    }
  }
  return result;
}
